import React, { useState, useCallback } from 'react';
import Select from 'b2b-ui-components-lib/lib/components/select';
import './bodyHeader.scss';
import { ActionButton } from 'rateCard/actionButton/actionButton';
import { DEFAULT_FILE_NAME, MEDIA_OPTIONS, PRODUCT_OPTIONS } from 'rateCard/constant/constant';
import { IDropDown } from 'rateCard/constant/rateCard.interface';
import { downloadRecords } from 'rateCard/services/rateCard.service';
import { findParamFromUrl, handleError } from 'common/utils/app.utils';
import FileSaver from 'file-saver';
import { getFileName } from 'home/view/manage-feasibility/utils';
import { fireAnalyitcsOnDownload, fireAnalyitcsOnSupport } from 'rateCard/analytics/analytics';

type Props = {
  product: IDropDown;
  companyName?: string;
  setProduct: Function;
  media: IDropDown;
  setMedia: React.Dispatch<React.SetStateAction<IDropDown>>;
  isStandardRate: boolean;
};

export const BodyHeader = ({ product, setProduct, isStandardRate, media, setMedia }: Props) => {
  const [isLoading, setIsLoading] = useState(false);
  const downloadHandler = useCallback(async () => {
    try {
      setIsLoading(true);
      const params = { partyId: findParamFromUrl('partyId'), product: product.key };
      const response = await downloadRecords(params);
      setIsLoading(false);
      const { data = {} } = response;
      const file = new Blob([data]);
      FileSaver.saveAs(file, getFileName(response, DEFAULT_FILE_NAME));
    } catch (error) {
      handleError(error);
      setIsLoading(false);
    }
    fireAnalyitcsOnDownload(product?.key);
  }, [product]);

  const onEmailClick = () => {
    fireAnalyitcsOnSupport(product?.key);
  };

  return (
    <div className="body_header">
      <div className="header_content">
        <div className="title">{isStandardRate ? 'Customer-specific' : 'Enterprise'} Rate Card </div>
        <ActionButton downloadHandler={downloadHandler} isLoading={isLoading} />
      </div>
      <div className="terms">
        <div className="mail-text">
          Please contact{' '}
          <a className="mail-url" href={`mailto:L1.Business.apps@airtel.com`}>
            <span onClick={onEmailClick}>L1.Business.apps@airtel.com</span>
          </a>{' '}
          to update the rate card for the customer.
        </div>
        *All charges are exclusive of GST. Additional charges may apply in case of CAPEX charges, third party charges, non-standard router or any non-standard configurations.{' '}
      </div>
      <div className="row product_selection">
        <div className="flg-lg-2 flg-md-6 flg-sm-12">
          <Select className="col-6" placeholder="Product Type" options={PRODUCT_OPTIONS} value={product} onChange={setProduct} />
        </div>
        <div className="flg-lg-2 flg-md-6 flg-sm-12">
          <Select className="col-6" placeholder="Media Type" options={MEDIA_OPTIONS} value={media} onChange={setMedia} />
        </div>
      </div>
      <div className="button_for_mobile">
        <ActionButton downloadHandler={downloadHandler} isLoading={isLoading} />
      </div>
    </div>
  );
};
